export interface EditionFeature {
  product: string
  features: string[]
}

export interface Edition {
  name: string
  subtitle?: string
  description: string
  productFeatures: EditionFeature[]
}

export const editionsData: Edition[] = [
  {
    name: 'Fundamentals',
    subtitle: 'Independent Schools only',
    description: 'Essential fundraising tools for Independent Schools',
    productFeatures: [
      {
        product: 'Online Giving',
        features: ['Smart Ask Amounts', 'Personalization', 'Smart Segments'],
      },
      {
        product: 'Outreach',
        features: ['Email Outreach', 'Smart Segments'],
      },
    ],
  },
  {
    name: 'Outreach',
    subtitle: 'Independent Schools only',
    description:
      'Comprehensive outreach and wealth screening for Independent Schools',
    productFeatures: [
      {
        product: 'Online Giving',
        features: [
          'Smart Ask Amounts',
          'Personalization',
          'Smart Segments',
          'Wealth Alerts',
        ],
      },
      {
        product: 'Outreach',
        features: ['Email Outreach', 'Texting', 'Smart Segments'],
      },
      {
        product: 'Wealth',
        features: ['Core', 'Wealth Alerts'],
      },
    ],
  },
  {
    name: 'Essentials',
    subtitle: 'Higher Ed',
    description: 'Core advancement tools for higher education institutions',
    productFeatures: [
      {
        product: 'Online Giving',
        features: [
          'Smart Ask Amounts',
          'Personalization',
          'Smart Segments',
          'Wealth Alerts',
        ],
      },
      {
        product: 'Outreach',
        features: ['Email Outreach', 'Smart Segments'],
      },
      {
        product: 'Wealth',
        features: ['Core', 'Wealth Alerts'],
      },
    ],
  },
  {
    name: 'Professional',
    subtitle: '',
    description: 'Advanced features for growing advancement teams',
    productFeatures: [
      {
        product: 'Online Giving',
        features: [
          'Smart Ask Amounts',
          'Personalization',
          'Smart Segments',
          'Wealth Alerts',
        ],
      },
      {
        product: 'Outreach',
        features: ['Email Outreach', 'Texting', 'Smart Segments'],
      },
      {
        product: 'Wealth',
        features: ['Core', 'Wealth Alerts'],
      },
    ],
  },
  {
    name: 'Enterprise',
    subtitle: '',
    description: 'Complete platform for sophisticated advancement operations',
    productFeatures: [
      {
        product: 'Online Giving',
        features: [
          'Smart Ask Amounts',
          'Personalization',
          'Smart Segments',
          'Wealth Alerts',
        ],
      },
      {
        product: 'Outreach',
        features: ['Email Outreach', 'Texting', 'Smart Segments'],
      },
      {
        product: 'Wealth',
        features: ['Core', 'Wealth Alerts'],
      },
    ],
  },
]

export function getEditionNames(): string[] {
  return editionsData.map((edition) => edition.name)
}

export function getEditionByName(name: string): Edition | undefined {
  return editionsData.find((edition) => edition.name === name)
}
